import {
  BODY_FONT,
  HEADER_FONT_11,
  HEADER_FILL,
  TITLE_FONT,
  VALUE_FILL,
  hideRowsThrough,
  setCell,
  setupSheetView,
  applyColumnLayout,
  hideColumnsAfter,
} from "./detailSheetCommon.js";
import {
  COL_D,
  COL_E,
  COL_F,
  COL_G,
  COL_H,
  COL_I,
  applyBorderPattern,
  applyMergedRowBorder,
  outerRowPatterns,
  writeDataRow,
} from "./principle2DetailHelpers.js";
import { safeText } from "./principle6SheetHelpers.js";
import { addSheetBackLink, PARENT_SHEETS } from "../sheetNavigation.js";

export const SHEET_NAME = "Public policy advocates";

const SHEET_TITLE = "Details of public policy positions advocated by the entity";

const WIDTHS = {
  A: 10.26953125,
  B: 10.26953125,
  C: 9.1796875,
  D: 9.1796875,
  E: 30.7265625,
  F: 30.7265625,
  G: 30.7265625,
  H: 30.7265625,
  I: 30.7265625,
  J: 9.1796875,
  K: 9.1796875,
  L: 10.26953125,
};

const BACK_ROW = 6;
const TITLE_ROW = 7;
const HEADER_ROW = 8;
const TEMPLATE_ROW = 9;
const SPACER_ROW = 10;
const DATA_START_ROW = 11;
const COL_END = COL_I;
const ALL_THIN = Array(6).fill("tttt");

export function buildPublicPolicyAdvocatesSheet(workbook, sectionC) {
  const ws = workbook.addWorksheet(SHEET_NAME, { views: [{ showGridLines: false }] });

  applyColumnLayout(ws, WIDTHS, ["A", "B", "K", "L"]);
  hideColumnsAfter(ws, 10);
  setupSheetView(ws, {
    ySplit: 10,
    xSplit: 1,
    topLeftCell: "D11",
    zoomScale: 80,
  });
  hideRowsThrough(ws, 4);

  addSheetBackLink(ws, PARENT_SHEETS.PRINCIPLE_7, {
    row: BACK_ROW,
    col: COL_END,
    mergeEnd: COL_END,
    align: "right",
    parentCell: "D8",
  });

  // Title at row 7 (reference layout)
  ws.mergeCells(TITLE_ROW, COL_D, TITLE_ROW, COL_END);
  setCell(ws, TITLE_ROW, COL_D, SHEET_TITLE, {
    font: TITLE_FONT,
    bold: true,
    fill: HEADER_FILL,
    bordered: false,
    align: "center",
  });
  applyMergedRowBorder(ws, TITLE_ROW, COL_D, COL_END, outerRowPatterns(COL_D, COL_END));
  ws.getRow(TITLE_ROW).height = 30;

  applyBorderPattern(ws, HEADER_ROW, COL_D, ALL_THIN);
  ws.getRow(HEADER_ROW).height = 30;
  [
    { col: COL_D, label: "Sr. no." },
    { col: COL_E, label: "Public policy advocated" },
    { col: COL_F, label: "Method resorted for such advocacy" },
    { col: COL_G, label: "Whether information available in public domain? (Yes/No)" },
    { col: COL_H, label: "Frequency of Review by Board" },
    { col: COL_I, label: "Web Link,if available" },
  ].forEach(({ col, label }) => {
    setCell(ws, HEADER_ROW, col, label, {
      font: HEADER_FONT_11,
      bold: false,
      bordered: false,
      align: "center",
    });
  });

  applyBorderPattern(ws, TEMPLATE_ROW, COL_D, ALL_THIN);
  for (let col = COL_D; col <= COL_END; col += 1) {
    setCell(ws, TEMPLATE_ROW, col, "", { bordered: false, font: BODY_FONT });
  }
  ws.getRow(TEMPLATE_ROW).height = 58;
  ws.getRow(TEMPLATE_ROW).hidden = true;

  ws.mergeCells(SPACER_ROW, COL_D, SPACER_ROW, COL_END);
  applyMergedRowBorder(ws, SPACER_ROW, COL_D, COL_END, outerRowPatterns(COL_D, COL_END));
  ws.getRow(SPACER_ROW).height = 30;

  const rows = sectionC?.principle7?.leadershipIndicator?.publicPolicyPositions || [];
  const dataRows = Array.isArray(rows) && rows.length ? rows : [{}];

  dataRows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    writeDataRow(
      ws,
      row,
      COL_D,
      COL_END,
      [
        { col: COL_D, value: idx + 1, align: "center", fill: null, font: BODY_FONT },
        {
          col: COL_E,
          value: safeText(item?.policyAdvocated, ""),
          align: "left",
          fill: VALUE_FILL,
        },
        {
          col: COL_F,
          value: safeText(item?.advocacyMethod, ""),
          align: "left",
          fill: VALUE_FILL,
        },
        {
          col: COL_G,
          value: safeText(item?.informationInPublicDomain, ""),
          align: "center",
          fill: VALUE_FILL,
        },
        {
          col: COL_H,
          value: safeText(item?.reviewFrequencyByBoard, ""),
          align: "left",
          fill: VALUE_FILL,
        },
        {
          col: COL_I,
          value: safeText(item?.webLink, ""),
          align: "left",
          fill: VALUE_FILL,
        },
      ],
      { patterns: ALL_THIN }
    );
    ws.getRow(row).height = 30;
  });

  return ws;
}
